import {
  IconDashboard,
  IconShoppingCart,
  IconFileInvoice,
  IconColumns,
  IconWallet,
  IconTruck,
  IconArrowBack,
} from '@tabler/icons'
import i18n from './../../utility/i18n'

function getTitle(key) {
  let title = i18n.t(key)
  if (title === undefined) {
    title = key
  }
  return title
}

const menu = {
  id: 'menu',
  title: 'Menu',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: getTitle('menu.dashboard'),
      type: 'item',
      url: '/',
      icon: IconDashboard,
      breadcrumbs: false,
    },
    {
      id: 'rfq',
      title: getTitle('menu.manage_rfq'),
      type: 'item',
      url: '/rfq',
      icon: IconFileInvoice,
      breadcrumbs: false,
    },
    {
      id: 'order',
      title: getTitle('menu.order'),
      type: 'item',
      url: '/order',
      icon: IconShoppingCart,
      breadcrumbs: false,
    },
    {
      id: 'return',
      title: getTitle('menu.return'),
      type: 'item',
      url: '/return',
      icon: IconArrowBack,
      breadcrumbs: false,
      children: [
        {
          id: 'return-balance',
          title: getTitle('menu.return_balance'),
          type: 'item',
          url: '/return/balance',
          breadcrumbs: false,
        },
      ],
    },
    {
      id: 'logistic',
      title: getTitle('menu.logistic'),
      type: 'collapse',
      icon: IconTruck,
      children: [
        {
          id: 'logistic-warehouse',
          title: getTitle('menu.warehouse_manage'),
          type: 'item',
          url: '/logistic/warehouse',
          breadcrumbs: false,
        },
      ],
    },
    {
      id: 'product',
      title: getTitle('menu.product'),
      type: 'item',
      icon: IconColumns,
      url: '/product',
      breadcrumbs: false,
    },
    {
      id: 'fund',
      title: getTitle('menu.fund'),
      type: 'collapse',
      icon: IconWallet,
      children: [
        {
          id: 'fund-balance',
          title: getTitle('menu.balance'),
          type: 'item',
          url: '/fund/balance',
          breadcrumbs: false,
        },
        // {
        //   id: 'fund-escrow',
        //   title: getTitle('menu.escrow_history'),
        //   type: 'item',
        //   url: '/fund/escrow',
        //   breadcrumbs: false,
        // },
        {
          id: 'fund-withdraw',
          title: getTitle('menu.withdraw'),
          type: 'item',
          url: '/fund/withdraw',
          breadcrumbs: false,
        },
        {
          id: 'fund-bank',
          title: getTitle('menu.manage_bank'),
          type: 'item',
          url: '/fund/bank',
          breadcrumbs: false,
        },
      ],
    },
  ],
}

export default menu
